import { render, staticRenderFns } from "./ApplicationDeclineSourceBadge.vue?vue&type=template&id=84b39054"
import script from "./ApplicationDeclineSourceBadge.vue?vue&type=script&lang=js"
export * from "./ApplicationDeclineSourceBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports